import { DirectoryGroups } from "./types.ts";

export const getBaseDirectoryStore = (): DirectoryGroups => ({
  groups: {},
  state: "not-loaded",
  lastUpdated: 0,
});
